import React, { Component } from "react";
import PropTypes from "prop-types";
import R from "ramda";
import debounce from "lodash/debounce";
import { AutoComplete, Input } from "@simpleryo/syw-uikit";
import { getBreakRuleMessage, validateField } from "../validators";
import FieldTheme from "../Field/FieldTheme";

export default class InputSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: []
    };
  }

  handleChange = value => {
    const { name, onChange, rules } = this.props;
    const { dataSource } = this.state;
    const convertVal = R.compose(
      R.pathOr(value, ["text"]),
      R.find(option => value === option.value)
    )(dataSource);
    const error = validateField(rules, convertVal);
    onChange(name, convertVal, error);
  };

  handleSearch = debounce(
    value => {
      if (value.length > 2) {
        const { onSearch } = this.props;
        Promise.resolve(onSearch(value)).then(dataSource => {
          this.setState({ dataSource });
        });
      }
    },
    500,
    {
      leading: false,
      trailing: true
    }
  );

  render() {
    const {
      value,
      error,
      className,
      label,
      description,
      hint,
      rules,
      placeholder = "",
      onSelect
    } = this.props;
    const { dataSource } = this.state;
    let errorMessage;
    if (R.not(R.isNil(error))) {
      errorMessage = getBreakRuleMessage(rules, error);
    }
    return (
      <FieldTheme
        className={className}
        label={label}
        description={description}
        hint={hint}
        error={error}
        errorMessage={errorMessage}
      >
        <AutoComplete
          value={value}
          dataSource={dataSource}
          placeholder={placeholder}
          onChange={this.handleChange}
          onSearch={this.handleSearch}
          onSelect={onSelect}
          getPopupContainer={trigger =>
            document.getElementById("slide__content") || trigger.parentNode
          }
        >
          <Input suffix={<i className="icon-search" />} />
        </AutoComplete>
      </FieldTheme>
    );
  }
}

InputSearch.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.node,
  hint: PropTypes.node,
  placeholder: PropTypes.string,
  rules: PropTypes.array,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  onSelect: PropTypes.func
};
